import type { IPopupContext, IPopupViewModel } from '@lingvo-news/contracts';

export class ReferralInvitePopupViewModel implements IPopupViewModel<null> {
	public readonly popupId = 'referral-invite' as const;

	private context: IPopupContext<null> | null = null;

	public constructor(
		public readonly title: string,
		public readonly webLabel: string,
		public readonly webLink: string,
		public readonly telegramLabel: string,
		public readonly telegramLink: string | null,
		public readonly shareButtonText: string,
		public readonly copyButtonText: string,
		public readonly closeButtonText: string,
	) {}

	public init(context: IPopupContext<null>): void {
		this.context = context;
	}

	public handleClose(): void {
		this.context?.closePopup(null);
	}
}
